<template>
  <!-- 还款成功 -->
  <div id="repaymentSuccessful">
    <div class="headerStatus">
      <img
        src="@/assets/images/success.png"
        alt=""
      />
      <h3>{{content}}</h3>
    </div>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">还款日期：</span>
        <span class="infoListRight">{{succInfo.repayTime}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款金额：</span>
        <span class="infoListRight">¥{{succInfo.repayTotalAmount}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款本金：</span>
        <span class="infoListRight">¥{{succInfo.repayAmount}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款利息：</span>
        <span class="infoListRight">¥{{succInfo.repayInterest}}</span>
      </li>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="goToNextPage"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Button from '@/components/Button.vue';

export default {
  name: 'repaymentSuccessful',
  data() {
    return {
      content: this.$route.query.productId === 'YL-YPD' ? '还款申请成功' : '还款成功', // 亿联还款是异步，不直接提示还款成功
      danger: 'danger',
      draw: '返回我的融资',
      succInfo: {},
      repaySuccessParams: sessionStorage.getItem('REPAY_SUCCESS_PARAMS') || '{"default":1}',
    };
  },
  components: {
    Button,
  },
  computed: {
    ...mapState({
      otherPages(val) {
        return val.otherPages;
      },
    }),
  },

  mounted() {
    document.title = this.content;
    this.getWithdrawalInfo();
  },
  methods: {
    async getWithdrawalInfo() {
      const { data = {} } = await this.$api.OtherPage.queryEchoInfo({
        drawId: localStorage.getItem('drawId'),
        orderId: localStorage.getItem('orderId'),
        pageId: '6',
        ...JSON.parse(this.repaySuccessParams)
      });
      this.succInfo = data;
    },
    goToNextPage() {
      this.$router.push('/supermarket/v2/myload');
    },
  },
};
</script>
<style scoped>
#repaymentSuccessful {
  background: #fff;
}

.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: #7d828e;
  font-size: 14px;
}
.infoListRight {
  color: #000;
  font-size: 14px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.headerStatus {
  padding-top: 35px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
</style>
